import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SharedFolder } from "../../Types/Project/SharedFolder";
import { getSharedFoldersData } from "../../Thunks/projectThunks";

interface ProjectSharedFolderSliceState {
  loader: boolean;
  sharedFolders: SharedFolder[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: ProjectSharedFolderSliceState = {
  loader: false,
  sharedFolders: [],
  errorDisplay: '',
}

// set state valu for api response
const sharedFolderSlice = createSlice({
  name: 'attendanceEmployees',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getSharedFoldersData.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getSharedFoldersData.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getSharedFoldersData.fulfilled, (state, action: PayloadAction<SharedFolder[]>) => {
        state.loader = false;
        state.sharedFolders = action.payload;
      })
  }
})

export const { } = sharedFolderSlice.actions
export default sharedFolderSlice.reducer
